"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genStyle = void 0;
const utils_1 = require("../utils");
const genStyle = ({ value, theme, form = ['edit'], }) => ({
    form,
    value: (theme ? (0, utils_1.setThemeVariable)(theme) : value),
});
exports.genStyle = genStyle;
